import {
    TICKET_LIST_GET_LIST,
    TICKET_LIST_GET_LIST_SUCCESS,
    TICKET_LIST_GET_LIST_ERROR,
    TICKET_LIST_GET_LIST_WITH_FILTER,
    TICKET_GET,
    TICKET_GET_SUCCESS,
    TICKET_GET_ERROR
} from '../actions';


export const getTicketList = () => ({
    type: TICKET_LIST_GET_LIST
});

export const getTicketListSuccess = (tickets, currentUser) => ({
    type: TICKET_LIST_GET_LIST_SUCCESS,
    payload: { tickets, currentUser }
});

export const getTicketListError = (error) => ({
    type: TICKET_LIST_GET_LIST_ERROR,
    payload: error
});

export const getTicketListWithFilter = (column, value) => ({
    type: TICKET_LIST_GET_LIST_WITH_FILTER,
    payload: { column, value }
});

export const getTicketListSearch = (startDate, endDate, hotel) => ({
    type: TICKET_LIST_GET_LIST_WITH_FILTER,
    payload: { startDate, endDate, hotel }
});

export const getTicket = (sessionID) => ({
    type: TICKET_GET,
    payload: sessionID
});

export const getTicketSuccess = (ticket) => ({
    type: TICKET_GET_SUCCESS,
    payload: { ticket }
});

export const getTicketError = (error) => ({
    type: TICKET_GET_ERROR,
    payload: error
});